<template>
  <my-dialog title="出入库记录" dialogType="form" :visible.sync="showDialog" :close-on-click-modal="false"
    @close="closeDialog" width="80%">

    <div class="item_info border_Green">
      <el-descriptions class="margin-top" title="库存商品信息" :column="4" border>
        <el-descriptions-item>
          <template slot="label">
            商品类型
          </template>
          {{ storeProductInfo.productInfo.typeName }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            商品名称
          </template>
          {{ storeProductInfo.productInfo.productName }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            规格
          </template>
          {{ storeProductInfo.productInfo.specification }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            单位
          </template>
          {{ storeProductInfo.productInfo.unit }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            价格（元）
          </template>
          {{ storeProductInfo.price }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            库存数量
          </template>
          {{ storeProductInfo.quantity }}
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <div class="selectContent">
      <el-radio-group v-model.number="selectType" @input="handleInputChange">
        <el-radio-button :label="1">入库记录</el-radio-button>
        <el-radio-button :label="2">出库记录</el-radio-button>
      </el-radio-group>
    </div>
    <div>
      <inputRecord ref="inputRecord"></inputRecord>
      <outputRecord ref="outputRecord"></outputRecord>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="closeDialog">关闭</el-button>
    </div>
  </my-dialog>
</template>

<script>
import inputRecord from "./inputRecord.vue";
import outputRecord from "./outputRecord.vue";
import {
  GetStoreProductDetail
} from "@/api/productApi.js";
export default {
  data() {
    return {
      selectType: 1,
      showDialog: false,
      keyId: "",
      productTypeKeyId: "",
      storeProductInfo: {
        productInfo: {
          typeName: "",
          productName: "",
          specfication: "",
          unit: "",
        },
        price: 0,
        quantity: 0,
      },
    };
  },
  // 注册组件
  components: {
    inputRecord,
    outputRecord,
  },
  created() { },
  computed: {},
  methods: {
    showRecordDialog(row) {
      this.showDialog = true;
      this.selectType = 1;
      this.keyId = row.keyId;
      this.productTypeKeyId = row.productTypeKeyId;
      this.getStoreProductDetail();
      this.$nextTick(() => {
        this.$refs.inputRecord.showInputRecordDialog(this.keyId, this.productTypeKeyId);
      });
    },
    handleInputChange(val) {
      this.selectType = val;
      if (val == 1) {
        this.$refs.inputRecord.showInputRecordDialog(this.keyId, this.productTypeKeyId);
        this.$refs.outputRecord.closeOutputDialog();
      } else if (val == 2) {
        this.$refs.inputRecord.closeInputRecordDialog();
        this.$refs.outputRecord.showOutputDialog(this.keyId);
      }
    },
    closeDialog() {
      this.$refs.inputRecord.closeInputRecordDialog();
      this.$refs.outputRecord.closeOutputDialog();
      this.keyId = "";
      this.showDialog = false;
    },
    getStoreProductDetail() {
      GetStoreProductDetail({
        keyId: this.keyId,
      }).then((res) => {
        if (res.code == 1) {
          this.storeProductInfo = res.data;
        } else {
          this.$message({
            type: "info",
            message: res.msg,
          });
        }
      }).catch((err) => {
        this.$message.error("数据加载失败，请稍后再试！");
      }).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>

<style scoped>
.selectContent {
  margin-top: 20rpx;
  display: flex;
  justify-content: center;
  align-items: center;
}

.item_info {
  border-left: 5px solid #55aaff;
  padding: 5px 10px;
  border-radius: 5px;
  margin-bottom: 15px;
  border-bottom: 2px solid #e9e7e7;
}

.border_Green {
  border-left: 5px solid #00cc66;
}
</style>